import { MicrosoftXboxControllerBatteryMediumIcon } from './MicrosoftXboxControllerBatteryMediumIcon';

/**
 * author: Austin Andrews
 * id 2B434E26-4ECE-4654-BBDC-4FE13CCCEE3E
 * name microsoft-xbox-controller-battery-medium
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/microsoft-xbox-controller-battery-medium.svg
 * tags
 * - Battery 
 * - Gaming / RPG 
 */
export const MicrosoftXboxGamepadBatteryMediumIcon = MicrosoftXboxControllerBatteryMediumIcon;
export default MicrosoftXboxGamepadBatteryMediumIcon